import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Box, Tooltip } from '@mui/material';

const TlCopyToClipboard = ({ classOverrides, text, title, toolTipPlacement, children, toolTipClassOverrides }) => {
  const [copied, setCopied] = useState(false);

  const copyText = (event, textToCopy) => {
    event.preventDefault();
    event.stopPropagation();

    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  };

  return (
    <Box className={classNames(classOverrides)} onClick={(event) => copyText(event, text)}>
      <Tooltip
        disableFocusListener
        disableTouchListener
        disableInteractive
        title={copied ? 'Copied!' : title}
        placement={toolTipPlacement}
        enterDelay={500}
        onClose={() => setCopied(false)}
        className={classNames(toolTipClassOverrides)}
      >
        {children}
      </Tooltip>
    </Box>
  );
};

TlCopyToClipboard.defaultProps = {
  classOverrides: [],
  text: null,
  title: 'Copy',
  toolTipPlacement: 'left',
  children: '',
  toolTipClassOverrides: [],
};

TlCopyToClipboard.propTypes = {
  classOverrides: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  text: PropTypes.string,
  title: PropTypes.string,
  toolTipPlacement: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func, PropTypes.string]),
  toolTipClassOverrides: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
};

export default TlCopyToClipboard;
